import React from "react";
import { AccordionMenuContextType } from "./types"; 

export const AccordionMenuContext = React.createContext<AccordionMenuContextType>({
  activeTab: null,
  expanded: [],
  onTabChange: (tab) => {},
  toggle: (id) => {},
});
